import ACTIONS from "./actions";

const initialState = {
  isLoading: false,
  isError: false,
  data: null,
  // command related states
  commandLoading: false,
  commandError: false,
  lastCommandResponse: null,
};

function chargerConfigReducer(state, action) {
  switch (action.type) {
    case ACTIONS.FETCH_CHARGER_CONFIG_INIT:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case ACTIONS.FETCH_CHARGER_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
      };
    case ACTIONS.FETCH_CHARGER_CONFIG_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case ACTIONS.SEND_OCPP_COMMAND_INIT:
      return {
        ...state,
        commandLoading: true,
        commandError: false,
        lastCommandResponse: null,
      };
    case ACTIONS.SEND_OCPP_COMMAND_SUCCESS:
      return {
        ...state,
        commandLoading: false,
        commandError: false,
        lastCommandResponse: action.payload,
      };
    case ACTIONS.SEND_OCPP_COMMAND_FAILURE:
      return {
        ...state,
        commandLoading: false,
        commandError: true,
      };
    default:
      return state;
  }
}

export { initialState };
export default chargerConfigReducer;
